import { type ReactElement } from 'react'
import * as S from './tv-show.styled'
import image from './assets/image.png'
import { LinkButton } from '../button/link-button'

export function TvShow (): ReactElement {
  return <S.Container>
    <figure>
      <img src={image} alt="" />
    </figure>
    <S.Content>
      <S.TextContainer>
        <S.TextContent>
          <h1>O seu sonho pode ser o próximo a se realizar… ao vivo na TV!</h1>
          <p>
            Toda semana, às 20h30 do Sábado, um filiado é escolhido para ter seu sonho transformado em realidade no Sabadão de TODOS, com o Renato Ambrósio, na Band. Se você for o escolhido, vai receber a notícia por e-mail, telefone ou até durante o próprio programa!
            <br />
            <br />
            <strong>Aberto para todos os filiados do Cartão de TODOS Sonhos.</strong>
          </p>
        </S.TextContent>
        <LinkButton to="https://idpv.cartaodetodos.com.br/dados-pessoais/?from_lead=1&idpv=593fe813-3579-442f-b0c2-17a883e92e24">Participar do próximo Sabadão!</LinkButton>
      </S.TextContainer>
    </S.Content>
  </S.Container>
}
